import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";

const SHADOWS = ["Le tentazioni", "Le paure", "Le dipendenze", "Le false sicurezze"];
const LIGHT = ["La fede", "La scelta", "L'obbedienza", "La dipendenza da Dio"];

export const WhyDesert = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} className="relative overflow-hidden px-5 py-32 sm:px-8 lg:py-48" data-testid="why-desert-section">
      <motion.div className="absolute inset-0" style={{ y: imgY }}>
        <img
          src="https://images.pexels.com/photos/5648779/pexels-photo-5648779.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1920"
          alt="Deserto al tramonto con luce all'orizzonte"
          className="h-[124%] w-full object-cover"
        />
        <div className="absolute inset-0 bg-night/78" />
        <div className="absolute inset-0 bg-gradient-to-b from-night via-transparent to-night" />
      </motion.div>

      <div className="relative z-10 mx-auto max-w-4xl">
        <Reveal>
          <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-gold">La metafora</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display text-4xl font-bold uppercase leading-[1.05] tracking-tight text-ivory sm:text-5xl lg:text-6xl" data-testid="why-desert-headline">
            Perché <span className="text-gold">"il Deserto"?</span>
          </h2>
        </Reveal>

        <Reveal delay={0.2} className="mt-10">
          <p className="max-w-2xl text-base leading-relaxed text-ivory/75 sm:text-lg">
            Nella Bibbia il deserto è il luogo in cui diminuisce il rumore e viene fuori ciò che
            realmente ci governa.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-10 sm:grid-cols-2" data-testid="why-desert-lists">
          <Reveal delay={0.25}>
            <ul className="space-y-3 border-l border-ivory/20 pl-6">
              {SHADOWS.map((s) => (
                <li key={s} className="font-display text-lg font-bold uppercase tracking-wide text-ivory/45">{s}</li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.35}>
            <p className="mb-4 text-xs uppercase tracking-[0.25em] text-gold">Ma anche</p>
            <ul className="space-y-3 border-l border-gold/60 pl-6">
              {LIGHT.map((s) => (
                <li key={s} className="font-display text-lg font-bold uppercase tracking-wide text-ivory">{s}</li>
              ))}
            </ul>
          </Reveal>
        </div>

        <Reveal delay={0.4} className="mt-14 max-w-2xl space-y-5">
          <p className="text-base leading-relaxed text-ivory/75 sm:text-lg">
            Per 40 giorni creerai uno spazio nella tua vita nel quale smettere di vivere in automatico.
          </p>
          <p className="font-serifq text-2xl italic leading-snug text-sand sm:text-3xl">
            Non per diventare perfetto.
          </p>
          <p className="text-base leading-relaxed text-ivory/75 sm:text-lg">
            Ma per tornare intenzionalmente verso Dio e ricominciare a costruire.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
